<template>
  <div class="full-view" v-if="settings">
    <mdb-mask class="overflow-auto gp-full-overlay" overlay="stylish-strong">
      <mdb-container class="gp-has-header">
        <div v-if="!showStartDialog">
          <mdb-card v-if="!game" class="mb-4">
            <mdb-card-header>
              <h3>Campfire Games</h3>
            </mdb-card-header>
            <mdb-card-body class="text-left">
              <div
                v-if="currentGroup && campfires && campfires.mayStartCampfire && campfires && campfires.playing.length==0">
                <mdb-btn @click="showStartDialog=true">
                  <mdb-icon color="danger" icon="fire"/>
                  Start a New Campfire
                </mdb-btn>
              </div>
              <div v-if="campfires && campfires.playing && campfires.playing.length>0">
                <h2>You are currently playing:</h2>
                <div v-for="game in campfires.playing" :key="game.id">
                  <avatar :avatar="game.hostAvatar" :name="game.hostName"/>
                  Campfire hosted by {{ game.hostName }}
                  <mdb-btn icon="play" @click="join(game)">Re-Join</mdb-btn>
                </div>
                <div style="clear:both">
                  <hr/>
                </div>
              </div>

              <div v-if="campfires && campfires.inProgress.length>0">
                <h2>Games in progress:</h2>
                <div v-for="game in campfires.inProgress" :key="game.id">
                  <avatar :avatar="game.hostAvatar" :name="game.hostName"/>
                  Campfire hosted by {{ game.hostName }}
                  <mdb-btn icon="play" @click="join(game)">Join</mdb-btn>
                </div>
                <div style="clear:both">
                  <hr/>
                </div>
              </div>

              <div v-if="campfires && campfires.inProgress.length == 0 && campfires.playing.length == 0"
                   class="text-info">
                No current campfires in progress.
              </div>
              <mdb-btn @click="getCampfires" icon="sync" size="sm" rounded>Refresh</mdb-btn>

              <mdb-card v-if="!game && campfires && campfires.leaderboard.length > 0" class="mb-4">
                <mdb-card-header>
                  <h3>Leaderboard
                    <mdb-icon icon="fire" color="danger" class="animated bounce"/>
                  </h3>
                </mdb-card-header>
                <mdb-card-body class="text-left">
                  <mdb-tabs :active="0" :links="leaderTabs" :transition-duration="0.5" card
                            class="mb-5"
                            tabs
                            transition-style="linear"
                  >
                    <div v-for="(lb,i) in campfires.leaderboard" :key="i" :slot="lb.gameName">
                      <div v-for="(l,j) in lb.leaders" :key="j">
                        <avatar :avatar="l.avatar" :name="l.name"/>
                        <div class="h4">{{ l.name }}</div>
                        <div class="text-danger h5 animated bounce">{{ l.score }}</div>

                        <div style="clear:both;"></div>
                      </div>
                    </div>

                  </mdb-tabs>
                </mdb-card-body>
              </mdb-card>

              <mdb-card>
                <mdb-card-header class="primary-color-dark text-white">
                  <h3>What is Campfire?</h3>
                </mdb-card-header>
                <mdb-card-body class="text-left">
                  <p>
                    Campfire is a set of games to be played <i>in person</i> with a group of 4 or more players. A few
                    games can be played with only 2.
                  </p>
                  <p>
                    The idea is for game nights, etc. that may be in locations where supplies (pens, paper, cards, etc.)
                    might
                    not be practical. For example, sitting around a campfire (hence the name). In the COVID era, it's
                    also
                    a way
                    to play games with your group via Zoom or other video conferencing tool.
                  </p>
                  <p>
                    Although the game uses a device to play, the game is still designed to promote <i>personal
                    interaction</i>.
                    Therefore, even though we could display the questions to you, we force the moderator of a round to
                    ask the question out loud, and to read the answers out loud before players can cast their vote. This
                    is to
                    promote interaction, and hopefully lots of fun and laughter.
                  </p>
                  <p>
                    We won't make you keep score by hand, though. That's not the fun part of game playing, so we'll take
                    care
                    of that for you!
                  </p>
                </mdb-card-body>
              </mdb-card>
            </mdb-card-body>
          </mdb-card>
        </div>
        <mdb-card v-if="showStartDialog">
          <mdb-card-header class="primary-color-dark text-white">
            <h3>New Campfire</h3>
          </mdb-card-header>
          <mdb-card-body>
            <start-dialog :isChange="false" @newCampfire="start" @cancelStart="showStartDialog=false"/>
          </mdb-card-body>
        </mdb-card>
      </mdb-container>
    </mdb-mask>

  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import Avatar from "../common/Avatar";
import {mapState} from 'vuex'
import StartDialog from "./StartDialog";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTabs
} from 'mdbvue';


export default {
  name: "group-campfire",
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbChipInput,
    mdbMask,
    bannerSmall,
    mdbBadge,
    mdbRow,
    mdbTabs,
    mdbCol,
    Avatar,
    StartDialog
  },
  computed: mapState({
                       currentGroup: state => state.currentGroup,
                       userDetails: state => state.userDetails,
                       settings: state => state.settings
                     }),
  data() {
    return {
      campfires: null,
      showStartDialog: false,
      showHostTools: false,
      showJoinDialog: false,
      gameType: null,
      game: null,
      joinGame: null,
      secret: "",
      leaderTabs: null,
      showGames: false,
    }
  },
  mounted() {
    document.title = "Campfire Games"
    this.getCampfires()
    if (this.settings && this.settings.staticImageUrl) this.setBackground()
    else setTimeout(() => {
      this.setBackground()
    }, 5000)
  },
  methods: {
    setBackground() {
      let el = document.getElementsByClassName("full-view")
      if (el) {
        el[0].setAttribute("style", "background-image: url('" + this.settings.staticImageUrl + "/campfire.jpg');")
      }
    },
    endPlay() {
      this.game = null
      this.getCampfires()
    },
    getCampfires() {
      this.$store.dispatch("setExecuting", true)
      api.get("/campfire/list/" + this.$route.params.id).then(
        (results) => {
          this.campfires = results.data
          this.leaderTabs = []
          for (let l of this.campfires.leaderboard) {
            this.leaderTabs.push({text: l.gameName})
          }
          if (!this.currentGroup || this.currentGroup.id != results.data.groupId) api.groupBasics(this.$route.params.id, "member");
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })


    },
    start(newGame) {
      api.post("/campfire/start/" + this.$route.params.id, newGame).then(
        (results) => {
          this.$router.push("/play-campfire/" + results.data.sessionId)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    join(game) {
      this.$router.push("/play-campfire/" + game.sessionId)
    },
    setStatus(status) {
      this.$store.dispatch("setExecuting", true)
      this.showHostTools = false
      api.post("/campfire/setStatus/" + this.game.id, {status: status}).then(
        (results) => {
          this.game.currentStatus = "Waiting"
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }
};

</script>
<style scoped>
@media screen and (max-width: 499px ) {
  .gp-fixed-action-btn {
    position: fixed;
    right: 5px;
    bottom: 10px;
    z-index: 998;
    margin-bottom: 0;
    overflow: hidden;
    height: 100px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
  }


}

@media screen and (min-width: 500px ) {

  .gp-fixed-action-btn {
    position: fixed;
    right: 35px;
    top: 100px;
    z-index: 998;
    margin-bottom: 0;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
    padding: 15px 15px 15px 15px;
    padding-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
